"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _apolloLinkBatchHttp = require("apollo-link-batch-http");

var _apolloLinkHttp = require("apollo-link-http");

var _unfetch = _interopRequireDefault(require("unfetch"));

var _getAuthHeaders = _interopRequireDefault(require("../../auth/getAuthHeaders"));

var _apolloLinkRetry = require("apollo-link-retry");

var _apolloLink = require("apollo-link");

var _onNetworkError = _interopRequireDefault(require("../onNetworkError"));

var _getUri = _interopRequireDefault(require("./getUri"));

var _default = function _default(_ref) {
  var endpointURL = _ref.endpointURL,
      batchInterval = _ref.batchInterval,
      canRetry = _ref.canRetry,
      batch = _ref.batch,
      getHeaders = _ref.getHeaders;

  var customFetch = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(uri, options) {
      var authHeaders, _i, _Object$keys, key, finalUri, result;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              authHeaders = (0, _getAuthHeaders["default"])(options.body, getHeaders);

              for (_i = 0, _Object$keys = Object.keys(authHeaders); _i < _Object$keys.length; _i++) {
                key = _Object$keys[_i];
                options.headers[key] = authHeaders[key];
              }

              _context.prev = 2;
              finalUri = (0, _getUri["default"])(uri, options);
              _context.next = 6;
              return (0, _unfetch["default"])(finalUri, options);

            case 6:
              result = _context.sent;
              return _context.abrupt("return", result);

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.warn('GraphQL request error:', _context.t0);
              throw _context.t0;

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10]]);
    }));

    return function customFetch(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var retryLink = new _apolloLinkRetry.RetryLink({
    attempts: function attempts(count, operation, error) {
      if (!canRetry) return false;
      if (typeof canRetry === 'function') return canRetry(count, operation, error);

      if (error && error.result && error.result.error === 'AuthError') {
        if (error.result.message.toLowerCase().includes('jwt')) {
          return false;
        } else if (error.result.message === 'nonceIsInvalid') {
          return count < 20;
        } else {
          console.log('got an auth error and will retry');
          (0, _onNetworkError["default"])({
            networkError: error
          }); // session should be reseted

          return count < 5;
        }
      }

      if (count > 10) return false;
      return !!error;
    },
    delay: function delay(count, operation, error) {
      return count * 500 * Math.random();
    }
  });
  var httpLink = batch ? new _apolloLinkBatchHttp.BatchHttpLink({
    uri: endpointURL + '/graphql',
    fetch: customFetch,
    batchInterval: batchInterval
  }) : new _apolloLinkHttp.HttpLink({
    uri: endpointURL + '/graphql',
    fetch: customFetch
  });
  return _apolloLink.ApolloLink.from([retryLink, httpLink]);
};

exports["default"] = _default;